module.exports = __webpack_public_path__ + "img/lev3.937a3b67.png";